module.exports = __webpack_public_path__ + "images/icons/icon-plus-2-e021d4ce.svg";